import 'reflect-metadata';

import { Container } from 'inversify';

import { CountriesModule } from '@/di/modules/country.module';
import { ExampleModule } from '@/di/modules/example.module';
import { LeaguesModule } from '@/di/modules/leagues.module';
import { LookupModule } from '@/di/modules/lookup.module';
import { MatchesModule } from '@/di/modules/matches.module';
import { PlayerModule } from '@/di/modules/player.module';
import { PlayersModule } from '@/di/modules/players.module';
import { ScheduleModule } from '@/di/modules/schedule.module';
import { StatesModule } from '@/di/modules/state.module';
import { TeamLeagueModule } from '@/di/modules/team-league.module';
import { TeamsModule } from '@/di/modules/teams.module';
import { UsersModule } from '@/di/modules/users.module';
import { DI_RETURN_TYPES, DI_SYMBOLS } from '@/di/types';
import { SystemLocationCourtsModule } from '@/di/modules/system-location-courts.module';

const ApplicationContainer = new Container({
	defaultScope: 'Singleton'
});

const initializeContainer = () => {
	ApplicationContainer.load(PlayerModule);
	ApplicationContainer.load(LeaguesModule);
	ApplicationContainer.load(ExampleModule);
	ApplicationContainer.load(ScheduleModule);
	ApplicationContainer.load(MatchesModule);
	ApplicationContainer.load(TeamLeagueModule);
	ApplicationContainer.load(PlayersModule);
	ApplicationContainer.load(TeamsModule);
	ApplicationContainer.load(StatesModule);
	ApplicationContainer.load(CountriesModule);
	ApplicationContainer.load(UsersModule);
	ApplicationContainer.load(LookupModule);
	ApplicationContainer.load(SystemLocationCourtsModule);
};

initializeContainer();

export function getInjection<K extends keyof typeof DI_SYMBOLS>(symbol: K): DI_RETURN_TYPES[K] {
	return ApplicationContainer.get(DI_SYMBOLS[symbol]);
}

export { ApplicationContainer };
